import {createContext, useReducer, useEffect} from 'react'
import Cookies from 'js-cookie';

export const AuthContext = createContext()

export const authReducer =  (state, action) =>{
    switch(action.type){
        case 'LOGIN':
            return { user:action.payload }
        case 'LOGOUT':
            return {user:null}
        default:
            return state
    }
}

export const AuthContextProvider = ({children}) =>{
   // Initialize synchronously from the cookie so the FIRST render already knows the
   // user is authenticated. Doing this in a useEffect caused guarded routes to redirect
   // to /login on direct load/refresh (before the effect ran), which then bounced to "/".
   const [state, dispatch] = useReducer(authReducer,{
    user: Cookies.get('token') || null
   })

   useEffect(() =>{
    // Keep state in sync if the cookie changes after mount (e.g. token refresh elsewhere).
    const user = Cookies.get('token')
    if(user){
        dispatch({type:'LOGIN',payload: user})
    }
   },[])


   return(
    <AuthContext.Provider value={{...state, dispatch}}>
{children}
    </AuthContext.Provider>
   )
}